import styled from "styled-components";

export const InvoiceNameContainer = styled.div`
  svg {
    margin-right: 0.5rem;
  }
`;
